import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import AdvancedSearch from "./_advance_search";

const useStyles = makeStyles({
  searchContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
    border: "1px solid #ccc",
    padding: 20,
    borderRadius: 7,
  },
  elementsContainer: {
    display: "flex",
    alignItems: "left",
  },
  header: {
    margin: "0 0 10px 0",
  },
  submitButton: {
    marginLeft: "10px!important"
  },
  advance_search_wrapper: {
    marginTop: "10px",
    textAlign: "right",
  }
});

const BasicSearch = ({onSubmit, onReport, ADVANCE_SEARCH, REPORT_DOWNLOADS}) => {
  const classes = useStyles();
  const [search, setSearch] = useState("");
  const [show_advance_search, setShowAdvanceSearch] = useState(false);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13 || event.key === "Enter") {
      onSubmit({search: search});
    }
  };

  const handleClickSubmit = (event) => {
    onSubmit({search: search});
  };

  const handleClickShowAdvanceSearch = (event) => {
    setShowAdvanceSearch(!show_advance_search);
  };

  return (
    <>
      <div className={classes.searchContainer}>
        <h5 className={classes.header}>Basic Search</h5>
        <div className={classes.elementsContainer}>
          <TextField
            id="basic-search"
            label="Search"
            value={search}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
            size="small"
            sx={{ width: "100%" }}
          />
          <Button
            className={classes.submitButton}
            variant="contained"
            size="medium"
            color="primary"
            onClick={handleClickSubmit}
          >
            Search
          </Button>
        </div>
        {ADVANCE_SEARCH != undefined && ADVANCE_SEARCH != [] && <div className={classes.advance_search_wrapper}>
          <Button size="small" onClick={handleClickShowAdvanceSearch}>
            Advance Search
          </Button>
        </div>}
      </div>
      {ADVANCE_SEARCH != undefined && ADVANCE_SEARCH != [] && show_advance_search && <AdvancedSearch onSubmit={onSubmit} onReport={onReport} ADVANCE_SEARCH_FIELDS={ADVANCE_SEARCH} REPORT_DOWNLOADS={REPORT_DOWNLOADS} />}
    </>
  );
}

export default BasicSearch;
